import {
  ReviewDetailResponse,
  ReviewListRequest,
  ReviewListResponse,
  ReviewUpdateRequest,
  ReviewUpdateResponse,
} from "../types/review";
import { adminApiClient, ApiResponse } from "./api";

export class AdminReviewService {
  /**
   * 검수할 AI 답변 목록을 조회합니다
   * GET /api/admin/reviews
   */
  async getReviews(
    request: ReviewListRequest
  ): Promise<ApiResponse<ReviewListResponse>> {
    const params = new URLSearchParams({
      page: request.page.toString(),
      limit: request.limit.toString(),
      status: request.status,
    });

    return adminApiClient.get<ReviewListResponse>(
      `/admin/reviews?${params.toString()}`
    );
  }

  /**
   * 특정 메시지의 검수 상세 정보를 조회합니다
   * GET /api/admin/reviews/:messageId
   */
  async getReviewDetail(
    messageId: string
  ): Promise<ApiResponse<ReviewDetailResponse>> {
    return adminApiClient.get<ReviewDetailResponse>(
      `/admin/reviews/${messageId}`
    );
  }

  /**
   * AI 답변에 대한 검수를 처리합니다 (승인/거부)
   * POST /api/admin/reviews
   */
  async updateReview(
    request: ReviewUpdateRequest
  ): Promise<ApiResponse<ReviewUpdateResponse>> {
    return adminApiClient.post<ReviewUpdateResponse>("/admin/reviews", request);
  }
}

export const adminReviewService = new AdminReviewService();
